import config from "@/utils/config";
import OSS from 'ali-oss'
import streamSaver from 'streamsaver'
import {
    printObj
} from "@/utils/debug"

import {
    checkFileFormatBeforeUpload
} from "@/utils/fileFormatUtil"

import {saveAs} from 'file-saver';
import axios from "axios";

export async function uploadFile2OSS(ossInfo, file, filePath, pb, getClient, fileFormatCheckCallback) {
    // console.log("--- uploadFile2OSS file type " + file.type)
    let isVaild = await checkFileFormatBeforeUpload(file)
    if (!isVaild) {
        let res = {
            status: -1,
            filePath: filePath,
            msg: "文件格式不支持.(视频请上传h264编码格式的mp4)"
        }
        if (fileFormatCheckCallback != null) {
            fileFormatCheckCallback(res)
        }
        return res
    }
    if (fileFormatCheckCallback != null) {
        fileFormatCheckCallback({
            status: 0
        })
    }
    // 实例化OSS Client。
    let client = new OSS({
        region: config.OSS_END_POINT,
        accessKeyId: ossInfo.AssumeRoleToken.AccessKeyId,
        accessKeySecret: ossInfo.AssumeRoleToken.AccessKeySecret,
        stsToken: ossInfo.AssumeRoleToken.SecurityToken,
        bucket: config.OSSBUCKET,
        timeout: 600000,
    });
    if (getClient != null) {
        getClient(client)
    }
    let res = await handleUpload(client, file, filePath, pb)
    return res;
}

async function handleUpload(client, file, filePath, pb) {
    let res
    let startDate = new Date();
    //大于10M用分片上传
    if (file.size >= 10 * 1024 * 1024) {
        res = await commonUpload(client, file, filePath, pb)
    } else {
        res = await multipartUpload(client, file, filePath, pb)
    }
    let endDate = new Date()
    console.log(endDate.getTime() - startDate.getTime())
    return res
}

/**
 * 普通上传
 */
async function commonUpload(client, file, filePath, pb) {
    console.log("普通上传");
    const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p, cpt, res) => {
            // console.log(p, cpt, res);
            if (pb != null) {
                pb(p, cpt, res)
            }
        },
    };
    try {
        // object表示上传到OSS的文件名称。
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        // client.put不能获取进度，所以也用multipartUpload，这个可以和分片合并
        let res = await client.multipartUpload(filePath, file, options)

        console.log("普通上传", res);
        return {
            status: 0,
            filePath: filePath,
            msg: "succ"
        }
    } catch (e) {
        console.error('error: %j', e);
        return {
            status: -1,
            filePath: filePath,
            msg: e
        }
    }
}

/**
 * 分片上传
 */
async function multipartUpload(client, file, filePath, pb) {
    console.log("分片上传");
    const options = {
        // 获取分片上传进度、断点和返回值。
        progress: (p, cpt, res) => {
            // console.log(p, cpt, res);
            if (pb != null) {
                pb(p, cpt, res)
            }
        },
        // 设置并发上传的分片数量。
        parallel: 4,
        // 设置分片大小。默认值为1 MB，最小值为100 KB。
        partSize: 5 * 1024 * 1024,
    };

    try {
        // object表示上传到OSS的文件名称。
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        let res = await client.multipartUpload(filePath, file, options)
        console.log("分片上传", res);
        return {
            status: 0,
            filePath: filePath,
            msg: "succ"
        }
    } catch (e) {
        console.error('error: %j', e);
        return {
            status: -1,
            filePath: filePath,
            msg: e
        }
    }
}

export function downloadFile(url, download = true) {//"Content-Type":'application/octet-stream',

    fetch(url, {
        method: 'GET',
        cache: 'no-cache'
    }).then(res=> {
        const fileStream = streamSaver.createWriteStream(url.substring(url.lastIndexOf("/") + 1), {
            size : res.headers.get("content-length")
        })
        const readableStream = res.body
        // more optimized
        if (window.WritableStream && readableStream.pipeTo) {
            return readableStream.pipeTo(fileStream)
                .then(() => console.log('done writing'))
        }
        window.writer = fileStream.getWriter()

        const reader = res.body.getReader()
        const pump = () => reader.read()
            .then(res => res.done
                ? window.writer.close()
                : window.writer.write(res.value).then(pump))

        pump()
    })
}
